import { render, staticRenderFns } from "./modal-header.vue?vue&type=template&id=fb37fbbe"
import script from "./modal-header.vue?vue&type=script&lang=js"
export * from "./modal-header.vue?vue&type=script&lang=js"
import style0 from "./modal-header.vue?vue&type=style&index=0&id=fb37fbbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports